import { render, staticRenderFns } from "./MainMenuComponent.vue?vue&type=template&id=e4317d48&scoped=true&"
import script from "./MainMenuComponent.vue?vue&type=script&lang=js&"
export * from "./MainMenuComponent.vue?vue&type=script&lang=js&"
function injectStyles (context) {
  
  
}

/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "e4317d48",
  null
  ,true
)

export default component.exports